import { Icon } from '@/components/icons/Icon'
import { type ComboBracketType } from '@/defs/combo'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedComboBracketBlock.module.scss'

type Props = {
  description: string
  label: string
  status: ComboBracketType['status']
  subtext: string
  title: string
}

const ICON_MAP: Record<Props['status'], IconType> = {
  invalid: 'xMark',
  valid: 'check',
  warning: 'exclamation',
}

export const FeaturedComboBracketBlock = ({ description, label, status, subtext, title }: Props) => (
  <div className={cn(styles.container, { status, styles })}>
    <div className={styles.label}>{label}</div>
    <h2 className={styles.title}>{title}</h2>
    <div className={styles.subtext}>{subtext}</div>
    <hr className={styles.spacer} />
    <p className={styles.description}>{description}</p>
    <div className={styles.icon}>
      <Icon name={ICON_MAP[status]} />
    </div>
  </div>
)
